import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';

export interface ErrorHandler {
    (err: ng.IHttpPromiseCallbackArg<RestError>): NotifyReturn;
}

function getErrorHandlerInstance(growl: Growl): ErrorHandler {
    return (err: ng.IHttpPromiseCallbackArg<RestError>): NotifyReturn => {
        const message =
            err && err.data && typeof err.data.message === 'string'
                ? err.data.message
                : null;
        const description =
            err && err.data && typeof err.data.description === 'string'
                ? err.data.description
                : null;
        const errorMessage =
            message ||
            description ||
            'An unknown error occurred. Please, check back later.';
        const errorCode =
            err && err.data && err.data.errorCode ? err.data.errorCode : '';
        const statusCode =
            err && err.data && err.data.status ? err.data.status : null;
        return growl.show(errorMessage, 'danger', { errorCode, statusCode });
    };
}

angular.module('app').factory('errorHandler', getErrorHandlerInstance);
